module.exports = __webpack_public_path__ + "files/859d828bbcbbcac386a959a387a6db31.svg";